import * as React from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { ChakraProvider, theme } from "@chakra-ui/react";

import "@fontsource/work-sans/100.css";
import "@fontsource/work-sans/200.css";
import "@fontsource/work-sans/300.css";
import "@fontsource/work-sans/400.css";
import "@fontsource/work-sans/500.css";
import "@fontsource/work-sans/600.css";
import "@fontsource/work-sans/700.css";
import "@fontsource/work-sans/800.css";
import "@fontsource/work-sans/900.css";

import { Navbar } from "./Navbar";
import { Home } from "./Home";
import { Secret } from "./Secret";

export const App = () => (
  <BrowserRouter>
    <ChakraProvider theme={theme}>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/secret" element={<Secret />} />
      </Routes>
    </ChakraProvider>
  </BrowserRouter>
);
